(function () {
  if (window.CCFiberblisssCartLoopReplacement) return;
  window.CCFiberblisssCartLoopReplacement = true;

  var SECTIONS = 'cart-items,cart-footer,cart-item-count,cart-live-region';

  function jsonRouteUrl(key, fallback) {
    var routes = window.theme && window.theme.routes ? window.theme.routes : {};
    var url = routes[key] || fallback;

    if (url.slice(-3) !== '.js') url += '.js';
    return url;
  }

  function themeString(key, fallback) {
    return window.theme && window.theme.strings && window.theme.strings[key]
      ? window.theme.strings[key]
      : fallback;
  }

  function requestHeaders() {
    return {
      'X-Requested-With': 'XMLHttpRequest',
      'Content-Type': 'application/json',
      Accept: 'application/json'
    };
  }

  function withSections(payload) {
    payload.sections = SECTIONS;
    payload.sections_url = window.location.pathname;

    return payload;
  }

  async function postJson(url, payload) {
    var response = await fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: requestHeaders(),
      body: JSON.stringify(payload)
    });
    var data = await response.json();

    if (!response.ok || data.status) {
      var message = data.description || data.message || themeString('cartError', 'Cart error');
      var error = new Error(message);
      error.responseData = data;
      throw error;
    }

    return data;
  }

  function postCartChange(payload) {
    return postJson(jsonRouteUrl('cart_change_url', '/cart/change.js'), withSections(payload));
  }

  function postCartAdd(payload) {
    return postJson(jsonRouteUrl('cart_add_url', '/cart/add.js'), withSections(payload));
  }

  function setCartError(message) {
    var errors = document.getElementById('cart-errors');
    if (errors) errors.textContent = message || '';
  }

  function lockCart() {
    document.dispatchEvent(new CustomEvent('shapes:cart:lock'));
  }

  function unlockCart() {
    document.dispatchEvent(new CustomEvent('shapes:cart:unlock'));
  }

  function setBusy(target, busy, busyText) {
    if (!target) return;

    var label = target.querySelector('[data-cc-loop-button-label]');

    target.disabled = busy;
    if (busy) {
      target.setAttribute('aria-busy', 'true');
      if (label) {
        label.setAttribute('data-original-label', label.textContent);
        label.textContent = busyText || 'Updating...';
      }
    } else {
      target.removeAttribute('aria-busy');
      if (label && label.getAttribute('data-original-label')) {
        label.textContent = label.getAttribute('data-original-label');
        label.removeAttribute('data-original-label');
      }
    }
  }

  function controlData(control) {
    return {
      key: control.getAttribute('data-line-key') || '',
      line: Number(control.getAttribute('data-line') || 0),
      quantity: Math.max(1, Number(control.getAttribute('data-quantity') || 1)),
      variantId: Number(control.getAttribute('data-variant-id') || 0),
      currentSellingPlan: control.getAttribute('data-current-selling-plan') || ''
    };
  }

  function payloadForLine(control, data) {
    var payload = {
      quantity: data.quantity
    };

    if (data.line) {
      payload.line = data.line;
    } else if (data.key) {
      payload.id = data.key;
    } else if (data.variantId) {
      payload.id = data.variantId;
    }

    return payload;
  }

  async function removeOriginalLine(control, data) {
    var basePayload = {
      quantity: 0
    };
    var payloads = [];

    if (data.key) payloads.push(Object.assign({}, basePayload, { id: data.key }));
    if (data.line) payloads.push(Object.assign({}, basePayload, { line: data.line }));
    if (!payloads.length && data.variantId) payloads.push(Object.assign({}, basePayload, { id: data.variantId }));

    var lastError;

    for (var i = 0; i < payloads.length; i += 1) {
      try {
        return await postCartChange(payloads[i]);
      } catch (error) {
        lastError = error;
      }
    }

    throw lastError || new Error(themeString('cartError', 'Cart error'));
  }

  async function replaceLine(control, sellingPlan) {
    var data = controlData(control);

    if (!data.variantId) throw new Error(themeString('cartError', 'Cart error'));

    var addPayload = {
      id: data.variantId,
      quantity: data.quantity
    };

    if (sellingPlan) addPayload.selling_plan = Number(sellingPlan);

    try {
      await postCartAdd(addPayload);
    } catch (singleAddError) {
      var itemPayload = {
        id: data.variantId,
        quantity: data.quantity
      };

      if (sellingPlan) itemPayload.selling_plan = Number(sellingPlan);

      await postCartAdd({
        items: [itemPayload]
      });
    }

    return removeOriginalLine(control, data);
  }

  async function changeLineSellingPlan(control, sellingPlan) {
    var data = controlData(control);
    var payload = payloadForLine(control, data);

    if (!payload.line && !payload.id) throw new Error(themeString('cartError', 'Cart error'));

    payload.selling_plan = sellingPlan ? Number(sellingPlan) : null;

    return postCartChange(payload);
  }

  function dispatchCartChange(data, control, originalTarget) {
    var detail = controlData(control);

    document.body.dispatchEvent(
      new CustomEvent('shapes:cart:cartqtychange', {
        bubbles: true,
        detail: {
          response: data,
          key: detail.key,
          quantity: detail.quantity,
          previousQuantity: detail.quantity,
          variantId: detail.variantId,
          originalTarget: originalTarget || null
        }
      })
    );
  }

  function dispatchCartError(error) {
    var message = error.message || themeString('cartError', 'Cart error');

    setCartError(message);
    document.dispatchEvent(
      new CustomEvent('theme:cart:error:other', {
        detail: {
          message: message,
          error: error
        }
      })
    );
  }

  async function updateLinePlan(control, sellingPlan, originalTarget) {
    if (!control) return;

    var data = controlData(control);
    var nextSellingPlan = sellingPlan || '';
    var busyText = nextSellingPlan ? 'Upgrading...' : 'Downgrading...';
    var updatedCart;

    lockCart();
    setCartError('');
    setBusy(originalTarget, true, busyText);

    try {
      if (data.currentSellingPlan) {
        try {
          updatedCart = await changeLineSellingPlan(control, nextSellingPlan);
        } catch (changeError) {
          updatedCart = await replaceLine(control, nextSellingPlan);
        }
      } else {
        updatedCart = await replaceLine(control, nextSellingPlan);
      }

      dispatchCartChange(updatedCart, control, originalTarget);
    } catch (error) {
      console.error(error);

      if (originalTarget && originalTarget.matches('[data-cc-loop-selling-plan]')) {
        originalTarget.value = data.currentSellingPlan || '';
      }

      dispatchCartError(error);
    } finally {
      setBusy(originalTarget, false);
      unlockCart();
    }
  }

  document.addEventListener('click', function (event) {
    if (!event.target || !event.target.closest) return;

    var button = event.target.closest('[data-cc-loop-cart-change]');
    if (!button) return;

    event.preventDefault();
    updateLinePlan(button.closest('[data-cc-loop-control]'), button.getAttribute('data-selling-plan'), button);
  }, true);

  document.addEventListener('change', function (event) {
    if (!event.target || !event.target.closest) return;

    var select = event.target.closest('[data-cc-loop-selling-plan]');
    if (!select) return;

    updateLinePlan(select.closest('[data-cc-loop-control]'), select.value, select);
  });
})();
